import React from 'react';
import {selectImage, WPMedia} from "./WPMedia";
import {FormLabel, Tooltip} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Add from "@material-ui/icons/Add";
import Clear from "@material-ui/icons/Clear";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import {Attachment} from "../SharedTypes";


export default function ImageList({attachments = [], onChange, label}:{
    attachments?: Attachment[], label?: string,
    onChange: (newValue: Attachment[]) => any,
}) {
    return (
        <Grid container alignItems="flex-end" spacing={2}>
            {label ? <Grid item xs={12} style={{margin: '1rem 0'}}><FormLabel>{label}</FormLabel></Grid> : null}
            {attachments.map((attachment, index) => <Grid item xs={12} sm={6} key={index}>
                <WPMedia onChange={newAttachment => onChange(attachments.map((a,i) => i === index ? newAttachment : a))}
                         attachment={attachment} additionalButtons={<Tooltip title={"Remove"}>
                    <IconButton color="default" style={{float: 'left', marginTop: '0.25rem'}} size="small" onClick={() =>
                        onChange(attachments.filter((a,i) => i !== index))}>
                    <Clear/>
                    </IconButton></Tooltip>} />
            </Grid>)}
            <Grid item xs={12}>
                <Button onClick={async () => onChange(attachments.concat([await selectImage()]))} color="primary" startIcon={<Add/>}>
                    Add Image</Button>
            </Grid>
        </Grid>
    );
}
